import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { isEmpty } from 'lodash';

import * as fromStore from '@core/store';

@Injectable()
export class CollectionResolver implements Resolve<Observable<any>> {
  constructor() {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const result = {};
    const stringParams = route.queryParams[fromStore.CTX];
    if (!isEmpty(stringParams)) {
      result[fromStore.PARENT_CTX] = JSON.parse(stringParams);
    }
    return of(result);
  }
}
